import { useLocation } from 'wouter'
import { ChevronLeft, Sun, Moon } from 'lucide-react'

const cabanaOptions = [
	{
		id: 'day',
		title: 'VIP Day Pool Cabanas',
		description: 'Reserve a cabana at the day pool',
		icon: Sun,
		href: '/cabanas/day',
	},
	{
		id: 'night',
		title: 'VIP Night Pool Cabanas',
		description: 'Reserve a cabana at the night pool',
		icon: Moon,
		href: '/cabanas/night',
	},
]

export default function CabanasPage() {
	const [, navigate] = useLocation()

	return (
		<div className="min-h-auto bg-[#18181B] h-full">
			<div className="max-w-5xl mx-auto px-5 pb-8 flex flex-col" style={{ minHeight: 'calc(100vh - 54px)' }}>
				{/* Header */}
				<div
					role="banner"
					className="sticky top-0 z-10 flex items-center gap-3 py-3 bg-[#18181B] backdrop-blur-md"
				>
					<button
						onClick={() => navigate('/')}
						className="h-8 w-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
					>
						<ChevronLeft className="h-[22px] w-[22px] text-[#ffffff]" />
					</button>
					<h1 className="text-[20px] leading-[18px] font-bold font-montserrat tracking-wide text-white">
						Cabanas
					</h1>
				</div>

				{/* Content */}
				<div className="flex items-center justify-center flex-1">
				<div className="grid gap-4 w-full">
					{cabanaOptions.map((option) => (
						<button
							key={option.id}
							onClick={() => navigate(option.href)}
							className="w-full bg-[#212124] hover:bg-[#2a2a2d] border border-white/5 rounded-2xl p-6 text-left transition-all duration-200 active:scale-[0.98] group"
						>
							<div className="flex items-center gap-4">
								<div className="h-14 w-14 rounded-full bg-[#EF4444]/10 flex items-center justify-center shrink-0">
									<option.icon className="h-7 w-7 text-[#EF4444]" />
								</div>
								<div className="flex-1 min-w-0">
									<h2 className="text-white font-semibold text-base font-montserrat mb-1">
										{option.title}
									</h2>
									<p className="text-[#BABABB] text-sm font-figtree">
										{option.description}
									</p>
								</div>
								<ChevronLeft className="h-5 w-5 text-[#BABABB] rotate-180 group-hover:translate-x-0.5 transition-transform" />
							</div>
						</button>
					))}
				</div>
				</div>
			</div>
		</div>
	)
}
